export const COLLECT_ROUTE_MATERIAL_COLOR_PALETTE: string[] = [
  '#B5E6A0',
  '#1D3408',
  '#97E75B',
  '#E7E8E9',
  '#313131',
  '#DFFED7',
  '#368E82',
  '#41F3F4',
  '#BDEAF5',
  '#208DF9',
  '#F7FE9E',
  '#65B2E9',
  '#7B1AF9',
  '#A5A2F7',
  '#472EFB',
];
